import { Form, Input } from 'antd';

import { TFieldProps } from 'types';

const { Item } = Form;
const { TextArea } = Input;

export const FormTextarea = ({
  name,
  label,
  rules,
  tooltip,
  autoSize,
  disabled,
  maxLength,
  showCount,
  readOnly,
  allowClear = true,
  inputStyles,
  placeholder,
  itemClassName,
  normalize,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
    normalize={normalize}
  >
    <TextArea
      readOnly={readOnly}
      allowClear={allowClear}
      style={inputStyles}
      disabled={disabled}
      showCount={showCount}
      maxLength={maxLength}
      autoSize={autoSize || { minRows: 3, maxRows: 5 }}
      placeholder={placeholder}
    />
  </Item>
);
